module.exports = __webpack_public_path__ + "images/jobs/cardWebdesigner.8031c06f.svg";